import { logger } from '../helpers/logger/logger'
import { ErrorTypes, ErrorTexts, Notifications } from '../lib/constants'

export const handleErrors = (
  errorCode: any,
  seterrorPage: any,
  handleNotification?: any,
) => {
  switch (errorCode) {
    case +ErrorTypes.CONCURRENT_CONNECTION:
      console.error('CONCURRENT_CONNECTION')
      seterrorPage(ErrorTexts.CONCURRENT_CONNECTION)
      break
    case +ErrorTypes.GENERAL_ERROR: //generalErrorSession
      logger.log('SYSTEM_ERROR', errorCode)
      seterrorPage(ErrorTexts.SYSTEM_ERROR)
      break
    case +ErrorTypes.ALREADY_LOGGED_IN:
      console.error('GENERAL_ERROR', errorCode)
      handleNotification(Notifications.invalidAction)
      break
    case +ErrorTypes.INVALID_SERVICE:
    case +ErrorTypes.NOT_LOGGED_IN:
    case +ErrorTypes.SESSION_CLOSED:
    case +ErrorTypes.INVALID_MESSAGE:
      console.error('INVALID_SERVICE')
      seterrorPage(ErrorTexts.INVALID_SESSION)
      break

    case +ErrorTypes.INVALID_TRANSFER:
      console.error('INVALID_TRANSFER')
      seterrorPage(ErrorTexts.MONEY_TRANSFER_ERROR)
      break
    case +ErrorTypes.INVALID_BET:
    case +ErrorTypes.INVALID_BET_AMOUNT:
      console.error('INVALID_BET')
      handleNotification(Notifications.invalidBet)
      break
    case +ErrorTypes.MAX_BET_LIMIT:
      console.error('MAX_BET_LIMIT')
      handleNotification(Notifications.maxbetlimit)
      break
    case +ErrorTypes.INSUFFICIENT_FUNDS:
      console.error('INSUFFICIENT_FUNDS')
      handleNotification(Notifications.notEnoughBalance)
      break
    case +ErrorTypes.INVALID_SESSION:
      console.error('INVALID_SESSION')
      seterrorPage(ErrorTexts.INVALID_SESSION)
      break
    case +ErrorTypes.NOT_FOUND:
      console.error('NOT_FOUND')
      handleNotification(Notifications.notFound)
      break
    default:
      console.error('CONNECTION_LOST ', errorCode)
      seterrorPage(ErrorTexts.CONNECTION_LOST)
      break
  }
}
